<template>
  <div>
    <folders-list-file-and-folder :hide-folders="true"></folders-list-file-and-folder>
  </div>
</template>

<script>
import FoldersListFileAndFolder from "@/components/folders/folders-list-file-and-folder";
import {mapMutations} from "vuex";
export default {
  name: "folders-vessels-option-owners",
  components: {FoldersListFileAndFolder},
  methods: {
    ...mapMutations(['setNameSectionFolders']),
  },
  mounted() {
    this.setNameSectionFolders('Vessels')
  }
}
</script>

<style scoped>

</style>